import { FC, PropsWithChildren, useMemo } from 'react';

import { type LoginJourneyContextType } from './types';
import { LoginJourneyContext } from './use-login-journey-context-provider';

export const LoginJourneyContextProvider: FC<
  PropsWithChildren<LoginJourneyContextType>
> = ({ children, loginJourney, amazonLoginJourney }) => {
  const value = useMemo(() => {
    return {
      loginJourney,
      amazonLoginJourney,
    };
  }, [loginJourney, amazonLoginJourney]);

  return (
    <LoginJourneyContext.Provider value={value}>
      {children}
    </LoginJourneyContext.Provider>
  );
};
